const navMenu = [
  { name: 'O centrum', path: '/about', icon: 'InfoIcon' },
  { name: 'Usługi', path: '/services', icon: 'ShoppingCartIcon' },
  { name: 'Kontakt', path: '/contact', icon: 'CallIcon' }
];

export default navMenu;